import React from 'react';
import styles from './Sex.module.css';
import { FormTitle } from '../../../Common/FormTitle';
import { ChoicesButton } from '../../../Common/CtaButton/ChoicesButton';
import { OtherButton } from '../../../Common/CtaButton/OtherButton';

export const Sex = () => {
    return (
        <div className={styles.wrapper}>
            <div>
                <FormTitle
                    formTitleText="あなたの性別は？"
                    dataViewLabel="EF_性別_pv"
                    dataClickLabel="EF_性別_戻る"
                />
                <div className={styles.selectionWrapper}>
                    <ChoicesButton
                        imageSrc="/foodslaboEf/img/step3/man-mark.png"
                        imageAlt="男性画像"
                        text="男性"
                        formKey={'sex'}
                        formValue={'man'}
                        displayFormKey={'sex'}
                        displayFormValue={'男性'}
                        dataClickLabel="EF_性別_男性"
                    />
                    <ChoicesButton
                        imageSrc="/foodslaboEf/img/step3/woman-mark.png"
                        imageAlt="女性"
                        text="女性"
                        formKey={'sex'}
                        formValue={'woman'}
                        displayFormKey={'sex'}
                        displayFormValue={'女性'}
                        dataClickLabel="EF_性別_女性"
                    />
                    <OtherButton
                        text="その他"
                        formKey={'sex'}
                        formValue={'other'}
                        displayFormKey={'sex'}
                        displayFormValue={'その他'}
                        dataClickLabel="EF_性別_その他"
                    />
                </div>
            </div>
        </div>
    );
};
